import React, { Fragment } from 'react';
import axios from 'axios';
import Qs from 'qs'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import hero9 from '../../assets/images/m1.jpg';

import {
    Modal, ModalBody, ModalHeader, ModalFooter,
    CardHeader,
    Badge,
    Progress,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    UncontrolledTooltip,
    Input,
    DropdownToggle,
    UncontrolledDropdown,
    DropdownMenu
} from 'reactstrap';

import Swal from 'sweetalert2'

export default class MemberProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isSearch: false, user_role: props.user_role, all_members: null, current_members: null, lang_version:props.lang_version };
    }

    componentDidMount() {
        let session = window.localStorage;
        axios.post(session.ch_action_url + "/action/get_all_user_list", Qs.stringify({})).then(res => {
            if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let all_members = res.data.data;
                let current_members = [];
                for (let i = 0; i < all_members.length; i++) {
                    if (all_members[i].roles.includes(this.state.user_role)) {
                        current_members.push(all_members[i]);
                    }
                }
                this.setState({ all_members: all_members, current_members: current_members });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.user_role != prevState.user_role) {
            let all_members = this.state.all_members;
            let current_members = [];
            for (let i = 0; i < all_members.length; i++) {
                if (all_members[i].roles.includes(this.state.user_role)) {
                    current_members.push(all_members[i]);
                }
            }
            this.setState({ current_members: current_members });
        }
    }

    static getDerivedStateFromProps(props, state) {
        let new_state = {};
        let flag = false;
        if (props.user_role !== state.user_role) {
            new_state.user_role = props.user_role;
            flag = true;
        }
        if(props.lang_version!==state.lang_version)
        {
            new_state.lang_version=props.lang_version;
            flag=true;
        }
        if (flag) {
            return new_state;
        }
        return null;
    }

    render() {
        return (
            <Fragment>
                <div className="pt-3 pb-3" id="show_main_content_div">
                    {(this.state.user_role === "conductor"||this.state.user_role==="instructor"||this.state.user_role==="advisor") && this.state.current_members !== null && this.state.current_members.length > 0 &&
                    this.state.current_members.map(member => (
                    <Card className="mb-5" style={{ maxWidth: "800px", margin: "auto" }}>
                        <div className="card-img-wrapper h-180px">
                            <img alt="..." className="card-img-top img-fit-container" src={hero9} />
                        </div>
                        <div className="card-body text-center card-body-avatar">
                            <a href="#/" onClick={e => e.preventDefault()} className="avatar-icon-wrapper card-box-hover rounded-circle card-box-hover-rise hover-scale-lg d-130">
                                <div className="avatar-icon rounded-circle">
                                    <img alt="..." className="img-fluid" src={member.image} />
                                </div>
                            </a>
                            <h3 className="font-weight-bold mt-4 mb-3">{member.name}</h3>
                            <p className="mb-2"  dangerouslySetInnerHTML={{ __html: this.state.lang_version==="en"?member.intro_en:member.intro_ch}}/>
                        </div>
                    </Card>))}

                    {false&&(this.state.user_role === "instructor" || this.state.user_role === "advisor"||this.state.user_role==="instructor") && this.state.current_members !== null && this.state.current_members.length > 0 &&
                        <div className="mb-3 mt-2 container p-2">
                            <Row>{this.state.current_members.map(member => (
                                <Col lg="6">
                                    <Card className="card-box mb-5 p-4">
                                        <div className="d-flex align-items-center mb-3">
                                            <div className="avatar-icon-wrapper rounded-circle mr-3">
                                                <div className="d-block p-0 avatar-icon-wrapper m-0 d-100">
                                                    <div className="rounded-circle overflow-hidden">
                                                        <img alt="..." className="img-fluid" src={member.image} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="w-100">
                                                <a href="#/" onClick={e => e.preventDefault()} className="font-weight-bold font-size-lg" title="...">{member.name}</a>
                                                <span className="text-black-50 d-block">{this.state.user_role === 3 ? "Instructor" : "Advisor"}</span>
                                            </div>
                                        </div>
                                        <p className="text-black-50 font-size-md mb-0">
                                            {this.state.lang_version==="en"?member.intro_en:member.intro_ch}
                                        </p>
                                        <div className="my-4 font-size-sm p-3 bg-secondary rounded-sm">
                                            <div className="d-flex justify-content-between">
                                                <span className="font-weight-bold">{this.state.lang_version==="en"?"Email:":"邮箱："}</span>
                                                <span className="text-black-50">{member.contact_email}</span>
                                            </div>
                                            <div className="d-flex justify-content-between py-2">
                                                <span className="font-weight-bold">{this.state.lang_version==="en"?"Job Description:":"职责："}</span>
                                                <span className="text-black-50">{member.job}</span>
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                            </Row>
                        </div>}

                    {(this.state.user_role === "committee" || this.state.user_role === "member") && this.state.current_members !== null && this.state.current_members.length > 0 &&
                        <div className="mb-3 mt-2 container p-2">
                            <Row>{this.state.current_members.map(member => (
                                <Col md="3">
                                    <Card className="card-border-top border-danger mb-5">
                                        <div className="text-center py-3">
                                            <div className="d-90 rounded-circle border-0 shadow-sm my-2 card-icon-wrapper bg-love-kiss btn-icon mx-auto text-center">
                                                <div className="avatar-icon-wrapper d-80">
                                                    <div className="avatar-icon d-80 rounded-circle"><img alt="..." src={member.image} /></div>
                                                </div>
                                            </div>
                                            <div className="font-size-xl font-weight-bold pt-2 text-black">{member.name}</div>
                                            <div className="opacity-10 pb-3">
                                                {member.job}
                                            </div>
                                            <div className="opacity-10 pb-3">
                                                {member.contact_email}
                                            </div>
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                            </Row>
                        </div>}
                </div>
            </Fragment>
        );
    }
}
